// userReducer.js
import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, SET_LOADING, LOGIN_TYPE } from './userActions';



const initialState = {
    isAuthenticated: false,
    user: null,
    error: null,
    loading: false,
    loginType: null
};
  
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload,
                error: null,
            };
        case LOGIN_TYPE:
            return {
                ...state,
                isAuthenticated: true,
                loginType: action.payload,
                error: null,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                error: action.payload,
            };
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                error: null,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
  
export default userReducer;